<app-page-heading [heading]="'Enterprise Management'" [hasBackButton]="false"></app-page-heading>

<mat-tab-group class="tab-container"
               headerPosition="above"
               [fitInkBarToContent]="false"
               [mat-stretch-tabs]="true"
               [selectedIndex]="activeTabIndex"
               (selectedTabChange)="onTabSelectionChanged($event)">
  <mat-tab label="Providers">
    <ng-template matTabContent>
      <div class="header-container">
        <div class="header-spacer">
          <mat-grid-list cols="3" rowHeight="75px">
            <mat-grid-tile>
              <mat-form-field class="filter-form-field-wide">
                <mat-label>Search for a provider by name, practice number OR licence number</mat-label>
                <input #providerSearch matInput type="text" [formControl]="providerFormControl"
                       data-qa="qa-input-provider"
                       (input)="onInputChangedSearchProviders($event)">
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
              <app-element-select displayLabel='Provider Group'
                                  [defaultValue]="providerGroup"
                                  [options]="providerGroups"
                                  (selectionChanged)="onProviderGroupSelectionChanged($event)">
              </app-element-select>
            </mat-grid-tile>
            <mat-grid-tile>
              <app-element-select displayLabel='Entity Status'
                                  [defaultValue]="providerStatus"
                                  [options]="providerStatuses"
                                  (selectionChanged)="onProviderStatusSelectionChanged($event)">
              </app-element-select>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
        <div class="header-spacer"></div>
        <div>
          <button class="button-spacer" [routerLink]="'/enterprise-management/add-provider'" mat-raised-button
                  color="accent">
            <mat-icon>add</mat-icon>
            Add Provider
          </button>
        </div>
      </div>
      
      <div *ngIf="providerDataSource" class="mat-elevation-z8 table-container">
        
        <table mat-table multiTemplateDataRows [dataSource]="providerDataSource" #providerSort="matSort" matSort
               (matSortChange)="sortData($event)">
          
          <ng-container matColumnDef="icons">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell>
              <span class="table-icon-container">
              <mat-icon class="table-icon font-medium" matTooltip="EDIT Provider"
                        (click)="editEntry($event, row.providerId)">edit
              </mat-icon>
              <mat-icon class="table-icon font-medium" matTooltip="DELETE Provider"
                        (click)="deleteEntry($event, row.providerId)"
                        [ngClass]="{'disabled': !hasPermissionsBasedOnRole}">
                delete
              </mat-icon>
              </span>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="providerId">
            <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-5">ID</th>
            <td *matCellDef="let row" mat-cell>{{ row.providerId }}</td>
          </ng-container>
          
          <ng-container matColumnDef="practiceNumber">
            <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Practice Number</th>
            <td *matCellDef="let row" mat-cell>{{ row.practiceNumber }}</td>
          </ng-container>
          
          <ng-container matColumnDef="name" class="w-15">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Provider Name</th>
            <td style="width: 350px;" *matCellDef="let row" mat-cell>{{ row.name | slice:0:50 }}</td>
          </ng-container>
          
          <ng-container matColumnDef="providerNetworkList">
            <th *matHeaderCellDef mat-header-cell class="w-10">Provider Network</th>
            <td style="width: 350px;" *matCellDef="let row" mat-cell>{{ row.providerNetworkList | slice:0:25 }}</td>
          </ng-container>
          
          <ng-container matColumnDef="businessLicenseNumber">
            <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">License Number</th>
            <td *matCellDef="let row" mat-cell>{{ row.businessLicenseNumber | slice:0:25 }}</td>
          </ng-container>
          
          <ng-container matColumnDef="businessType">
            <th *matHeaderCellDef mat-header-cell class="w-10">Business Type</th>
            <td *matCellDef="let row" mat-cell>{{ row.businessType?.name }}</td>
          </ng-container>
          
          <ng-container matColumnDef="entityStatus">
            <th *matHeaderCellDef mat-header-cell class="w-10">Entity Status</th>
            <td *matCellDef="let row" mat-cell>{{ row.entityStatus?.name }}</td>
          </ng-container>
          
          <ng-container matColumnDef="providerFacilityType">
            <th *matHeaderCellDef mat-header-cell class="w-10">Facility Type</th>
            <td *matCellDef="let row" mat-cell>{{ row.providerFacilityType?.name }}</td>
          </ng-container>
          
          <ng-container matColumnDef="startDate">
            <th *matHeaderCellDef mat-header-cell class="w-5">start Date</th>
            <td *matCellDef="let row" mat-cell>{{ row.startDate | date: dateFormat }}</td>
          </ng-container>
          
          <ng-container matColumnDef="bankAccount">
            <th *matHeaderCellDef mat-header-cell>Bank Account</th>
            <td *matCellDef="let row" mat-cell>
              <div class="flex justify-start items-baseline">
                <app-open-link-as [icon]="DisplayIcon.DialogIcon"
                                  (onClick)="openProviderBankAccountDialog($event, row.providerId)"></app-open-link-as>
                <p>{{ getProviderBankAccountDisplayString(row.bankAccount) }}</p>
              </div>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="expandedDetail">
            <td *matCellDef="let row" mat-cell [attr.colspan]="providerDisplayedColumns.length">
              <div class="row-detail-container" [@detailExpand]="row == providerExpandedRow ? 'expanded' : 'collapsed'">
                <b>Provider Name: </b>{{ row.name }}<br>
                <b>End Date: </b>{{ row.endDate | date: dateFormat }}<br>
                <b>License Expiry: </b>{{ row.businessLicenseExpiryDate | date: dateFormat }}<br>
                <b>GST Number: </b>{{ row.gstNumber }}<br>
                <b>Billing Id: </b>{{ row.billingId }}<br>
                <b>Country: </b>{{ row.country?.name }}<br>
                <b>Regulator: </b>{{ row.regulator?.name }}<br>
                <b>Processing Class: </b>{{ row.processingClass?.name }}<br>
                <b>Vat Number: </b>{{ row.vatNumber }}<br>
                <b>Vat Override: </b>{{ row.vatOverride }}<br>
                <b>Sanction Indicator: </b>{{ row.sanctionIndicator }}<br>
                <b>Sanction Reference: </b>{{ row.sanctionReference }}<br>
                <b>Sanction Check Date: </b>{{ row.sanctionCheckDate | date: dateFormat }}<br>
                <b>Created By: </b>{{ row.createdBy }}<br>
                <b>Created Date: </b>{{ row.created | date: dateTimeFormat }}<br>
                <b>Updated By: </b>{{ row.updatedBy }}<br>
                <b>Updated Date: </b>{{ row.updated | date: dateTimeFormat }}<br>
              </div>
            </td>
          </ng-container>
          
          <tr mat-header-row *matHeaderRowDef="providerDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: providerDisplayedColumns;" class="row"
              [class.expanded-row]="providerExpandedRow == row"
              (click)="providerExpandedRow = providerExpandedRow === row ? null : row">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
        
        </table>
        
        <mat-paginator #providerPaginator (page)="pageChanged($event)" [length]="providerTableControl.length"
                       [pageSize]="providerTableControl.pageSize" [pageIndex]="0"
                       [pageSizeOptions]="providerTableControl.pageSizeOptions">
        </mat-paginator>
      
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Provider Groups">
    <ng-template matTabContent>
      <div class="header-container">
        <div>
          <mat-form-field class="filter-form-field-wide">
            <mat-label>Search for a provider group by name or practice number</mat-label>
            <input #providerGroupSearch matInput type="text" [formControl]="providerGroupFormControl"
                   data-qa="qa-input-provider-group"
                   (input)="onInputChangedSearchProviderGroups($event)">
          </mat-form-field>
        </div>
        <span class="header-spacer"></span>
        <div>
          <button class="button-spacer" [routerLink]="'/enterprise-management/add-provider-group'" mat-raised-button
                  color="accent">
            <mat-icon>add</mat-icon>
            Add Provider Group
          </button>
        </div>
      </div>
      
      <div *ngIf="providerGroupDataSource" class="mat-elevation-z8 table-container">
        
        <table mat-table multiTemplateDataRows [dataSource]="providerGroupDataSource" #providerGroupSort="matSort"
               matSort (matSortChange)="sortData($event)">
          
          <ng-container matColumnDef="icons">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell>
              <mat-icon class="table-icon" matTooltip="EDIT Provider Group"
                        (click)="editEntry($event, row.providerGroupId)">edit
              </mat-icon>
              <mat-icon class="table-icon" matTooltip="DELETE Provider Group"
                        (click)="deleteEntry($event, row.providerGroupId)"
                        [ngClass]="{'disabled': !hasPermissionsBasedOnRole}">delete
              </mat-icon>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="providerGroupId">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
            <td *matCellDef="let row" mat-cell>{{ row.providerGroupId }}</td>
          </ng-container>
          
          <ng-container matColumnDef="practiceNumber">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Practice Number</th>
            <td *matCellDef="let row" mat-cell>{{ row.practiceNumber }}</td>
          </ng-container>
          
          <ng-container matColumnDef="name">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Provider Group Name</th>
            <td *matCellDef="let row" mat-cell>{{ row.name | slice:0:50 }}</td>
          </ng-container>
          
          <ng-container matColumnDef="businessLicenseNumber">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>License Number</th>
            <td *matCellDef="let row" mat-cell>{{ row.businessLicenseNumber | slice:0:25 }}</td>
          </ng-container>
          
          <ng-container matColumnDef="businessType">
            <th *matHeaderCellDef mat-header-cell>Business Type</th>
            <td *matCellDef="let row" mat-cell>{{ row.businessType.name }}</td>
          </ng-container>
          
          <ng-container matColumnDef="entityStatus">
            <th *matHeaderCellDef mat-header-cell>Entity Status</th>
            <td *matCellDef="let row" mat-cell>{{ row.entityStatus?.name }}</td>
          </ng-container>
          
          
          <ng-container matColumnDef="startDate">
            <th *matHeaderCellDef mat-header-cell>start Date</th>
            <td *matCellDef="let row" mat-cell>{{ row.startDate | date: dateFormat }}</td>
          </ng-container>
          
          <ng-container matColumnDef="expandedDetail">
            <td *matCellDef="let row" mat-cell [attr.colspan]="providerGroupDisplayedColumns.length">
              <div class="row-detail-container"
                   [@detailExpand]="row == providerGroupExpandedRow ? 'expanded' : 'collapsed'">
                <b>Provider Group Name: </b>{{ row.name }}<br>
                <b>End Date: </b>{{ row.endDate | date: dateFormat }}<br>
                <b>License Expiry: </b>{{ row.businessLicenseExpiryDate | date: dateFormat }}<br>
                <b>GST Number: </b>{{ row.gstNumber }}<br>
                <b>Regulator: </b>{{ row.regulator?.name }}<br>
                <b>Processing Class: </b>{{ row.processingClass?.name }}<br>
                <b>Country: </b>{{ row.country?.name }}<br>
                <b>Vat Override: </b>{{ row.vatOverride }}<br>
                <b>Vat Number: </b>{{ row.vatNumber }}<br>
                <b>Sanction Indicator: </b>{{ row.sanctionIndicator }}<br>
                <b>Sanction Reference: </b>{{ row.sanctionReference }}<br>
                <b>Sanction Check Date: </b>{{ row.sanctionCheckDate | date: dateFormat }}<br>
                <b>Created By: </b>{{ row.createdBy }}<br>
                <b>Created Date: </b>{{ row.created | date: dateTimeFormat }}<br>
                <b>Updated By: </b>{{ row.updatedBy }}<br>
                <b>Updated Date: </b>{{ row.updated | date: dateTimeFormat }}<br>
              </div>
            </td>
          </ng-container>
          
          <tr mat-header-row *matHeaderRowDef="providerGroupDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: providerGroupDisplayedColumns;" class="row"
              [class.expanded-row]="providerGroupExpandedRow == row"
              (click)="providerGroupExpandedRow = providerGroupExpandedRow === row ? null : row">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
        
        </table>
        
        <mat-paginator #providerGroupPaginator (page)="pageChanged($event)" [length]="providerGroupTableControl.length"
                       [pageSize]="providerGroupTableControl.pageSize" [pageIndex]="0"
                       [pageSizeOptions]="providerGroupTableControl.pageSizeOptions">
        </mat-paginator>
      
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Provider Networks">
    <ng-template matTabContent>
      <app-provider-networks></app-provider-networks>
    </ng-template>
  </mat-tab>
  <mat-tab label="Provider Price Lists">
    <ng-template matTabContent>
      <div class="header-container">
        <div>
          <mat-form-field class="filter-form-field">
            <mat-label>Search for a provider's price list by name</mat-label>
            <input #providerPriceListSearch matInput type="text" [formControl]="providerPriceListFormControl"
                   data-qa="qa-input-provider-price-list"
                   (input)="onInputChangedSearchProviderPriceLists($event)">
          </mat-form-field>
        </div>
        <span class="header-spacer"></span>
        <div>
          <button class="button-spacer" [routerLink]="'/enterprise-management/add-provider-price-list'"
                  mat-raised-button color="accent">
            <mat-icon>add</mat-icon>
            Add Price List
          </button>
        </div>
      </div>
      
      <div *ngIf="providerPriceListDataSource" class="mat-elevation-z8 table-container">
        
        <table mat-table multiTemplateDataRows [dataSource]="providerPriceListDataSource"
               #providerPriceListSort="matSort" matSort (matSortChange)="sortData($event)">
          
          <ng-container matColumnDef="icons">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell>
              <mat-icon class="table-icon"
                        matTooltip="EDIT Price List" (click)="editEntry($event, row.providerPriceListId)">edit
              </mat-icon>
              <mat-icon class="table-icon"
                        matTooltip="DELETE Price List" (click)="deleteEntry($event, row.providerPriceListId)">
                delete
              </mat-icon>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="providerPriceListId">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
            <td *matCellDef="let row" mat-cell>{{ row.providerPriceListId }}</td>
          </ng-container>
          
          <ng-container matColumnDef="name">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
            <td *matCellDef="let row" mat-cell>{{ row?.name }}</td>
          </ng-container>
          
          <ng-container matColumnDef="providerPriceListType">
            <th *matHeaderCellDef mat-header-cell>Provider Price List Type</th>
            <td *matCellDef="let row" mat-cell>{{ row?.providerPriceListType?.name }}</td>
          </ng-container>
          
          <ng-container matColumnDef="administrator">
            <th *matHeaderCellDef mat-header-cell>Administrator</th>
            <td *matCellDef="let row" mat-cell>{{ row?.administrator?.name }}</td>
          </ng-container>
          
          <ng-container matColumnDef="expandedDetail">
            <td *matCellDef="let row" mat-cell [attr.colspan]="providerPriceListDisplayedColumns.length">
              <div class="row-detail-container"
                   [@detailExpand]="row == providerPriceListExpandedRow ? 'expanded' : 'collapsed'">
                <b>Created By: </b>{{ row.createdBy }}<br>
                <b>Created Date: </b>{{ row.created | date: dateTimeFormat }}<br>
                <b>Updated By: </b>{{ row.updatedBy }}<br>
                <b>Updated Date: </b>{{ row.updated | date: dateTimeFormat }}<br>
              </div>
            </td>
          </ng-container>
          
          <tr mat-header-row *matHeaderRowDef="providerPriceListDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: providerPriceListDisplayedColumns;" class="row"
              [class.expanded-row]="providerPriceListExpandedRow == row"
              (click)="providerPriceListExpandedRow = providerPriceListExpandedRow === row ? null : row">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
        
        </table>
        
        <mat-paginator #providerPriceListPaginator (page)="pageChanged($event)"
                       [length]="providerPriceListTableControl.length"
                       [pageSize]="providerPriceListTableControl.pageSize" [pageIndex]="0"
                       [pageSizeOptions]="providerPriceListTableControl.pageSizeOptions">
        </mat-paginator>
      
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Persons">
    <ng-template matTabContent>
      <greydom-persons></greydom-persons>
    </ng-template>
  </mat-tab>
  <mat-tab label="Policies">
    <ng-template matTabContent>
      <div class="header-container">
        <div>
          <mat-form-field class="filter-form-field">
            <mat-label>Search for a policy by number</mat-label>
            <input #policySearch matInput type="text" [formControl]="policyFormControl"
                   data-qa="qa-input-policy"
                   (input)="onInputChangedSearchPolicy($event)">
          </mat-form-field>
        </div>
        <span class="header-spacer"></span>
      
      </div>
      
      <div *ngIf="policyDataSource" class="mat-elevation-z8 table-container">
        
        <table mat-table multiTemplateDataRows [dataSource]="policyDataSource" #policySort="matSort" matSort
               (matSortChange)="sortData($event)">
          
          <ng-container matColumnDef="icons">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell>
              <mat-icon class="table-icon" matTooltip="EDIT Policy" (click)="editEntry($event, row.policyId)">edit
              </mat-icon>
              <!--              <mat-icon class="table-icon" matTooltip="DELETE Policyholder" (click)="deleteEntry($event, row.policyId)">-->
              <!--                delete-->
              <!--              </mat-icon>-->
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Policy Name</th>
            <td *matCellDef="let row" mat-cell> {{ row.name | slice:0:50 }}</td>
          </ng-container>
          <ng-container matColumnDef="number">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Policy Number</th>
            <td *matCellDef="let row" mat-cell> {{ row.number | slice:0:25 }}</td>
          </ng-container>
          <ng-container matColumnDef="startDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
            <td *matCellDef="let row" mat-cell> {{ row?.startDate | date: dateFormat }}</td>
          </ng-container>
          <ng-container matColumnDef="endDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
            <td *matCellDef="let row" mat-cell> {{ row?.endDate | date: dateFormat }}</td>
          </ng-container>
          <ng-container matColumnDef="policyholder">
            <th *matHeaderCellDef mat-header-cell>Policy holder</th>
            <td *matCellDef="let row" mat-cell> {{ row?.policyholder?.name }}</td>
          </ng-container>
          <ng-container matColumnDef="payer">
            <th *matHeaderCellDef mat-header-cell>Payer</th>
            <td *matCellDef="let row" mat-cell> {{ row?.payer?.name }}</td>
          </ng-container>
          <ng-container matColumnDef="administrator">
            <th *matHeaderCellDef mat-header-cell>Administrator</th>
            <td *matCellDef="let row" mat-cell> {{ row?.administrator?.name }}</td>
          </ng-container>
          <ng-container matColumnDef="broker">
            <th *matHeaderCellDef mat-header-cell>Broker</th>
            <td *matCellDef="let row" mat-cell> {{ row?.broker?.name }}</td>
          </ng-container>
          <ng-container matColumnDef="processingClass">
            <th *matHeaderCellDef mat-header-cell>Class</th>
            <td *matCellDef="let row" mat-cell> {{ row?.processingClass?.name }}</td>
          </ng-container>
          <ng-container matColumnDef="currency">
            <th *matHeaderCellDef mat-header-cell>Currency</th>
            <td *matCellDef="let row" mat-cell> {{ row?.currency?.name }}</td>
          </ng-container>
          <ng-container matColumnDef="expandedDetail">
            <td *matCellDef="let row" mat-cell [attr.colspan]="policyDisplayedColumns.length">
              <div class="row-detail-container" [@detailExpand]="row == policyExpandedRow ? 'expanded' : 'collapsed'">
                <b>Policy Name: </b>{{ row.name }}<br>
                <b>Activation Date: </b>{{ row?.activationDate | date: dateFormat }}<br>
                <b>Broker Commission: </b>{{ row?.brokerCommission }}<br>
                <b>Billing Day Number: </b>{{ row?.billingDayNumber }}<br>
                <b>First Billing Date: </b>{{ row?.firstBillingDate | date: dateFormat }}<br>
                <b>Application Date: </b>{{ row?.applicationDate | date: dateFormat }}<br>
                <b>payer: </b>{{ row?.payer?.name }}<br>
                <b>ProRata Type: </b>{{ row?.proRataType?.name }}<br>
                <b>Under Writing Type: </b>{{ row?.underwritingType?.name }}<br>
                <b>Premium Billing Interval: </b>{{ row?.premiumBillingInterval?.name }}<br>
                <b>Bill To Group: </b>{{ row?.billToGroup?.name }}<br>
                <b>Renewal Of Policy: </b>{{ row?.renewalOfPolicy?.name }}<br>
                <b>Renewed By Policy: </b>{{ row?.renewedByPolicy?.name }}<br>
                <b>Currency: </b>{{ row?.currency?.name }}<br>
                <b>Created By: </b>{{ row?.createdBy }}<br>
                <b>Created Date: </b>{{ row?.created | date: dateTimeFormat }}<br>
                <b>Updated By: </b>{{ row?.updatedBy }}<br>
                <b>Updated Date: </b>{{ row?.updated | date: dateTimeFormat }}<br>
              </div>
            </td>
          </ng-container>
          
          <tr mat-header-row *matHeaderRowDef="policyDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: policyDisplayedColumns;" class="row"
              [class.expanded-row]="policyExpandedRow == row"
              (click)="policyExpandedRow = policyExpandedRow === row ? null : row">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
        
        </table>
        
        <mat-paginator #policyPaginator (page)="pageChanged($event)" [length]="policyTableControl.length"
                       [pageSize]="policyTableControl.pageSize" [pageIndex]="0"
                       [pageSizeOptions]="policyTableControl.pageSizeOptions">
        </mat-paginator>
      
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Applications">
    <ng-template matTabContent>
      <greydom-applications></greydom-applications>
    </ng-template>
  </mat-tab>
  <mat-tab label="Policyholder Groups">
    <ng-template matTabContent>
      <greydom-policyholder-groups
        [navigateTo]="'/enterprise-management/add-policyholder-group'"></greydom-policyholder-groups>
    </ng-template>
  </mat-tab>
  <mat-tab label="Brokers">
    <ng-template matTabContent>
      <greydom-brokers></greydom-brokers>
    </ng-template>
  </mat-tab>
  <mat-tab label="Products">
    <ng-template matTabContent>
      <app-products></app-products>
    </ng-template>
  </mat-tab>
  <mat-tab label="Benefits">
    <ng-template matTabContent>
      <app-benefits></app-benefits>
    </ng-template>
  </mat-tab>
  <mat-tab label="Limits">
    <ng-template matTabContent>
      <app-limits></app-limits>
    </ng-template>
  </mat-tab>
</mat-tab-group>
